<div class="px-3 pt-3">
  <mat-card>
    <mat-card-content class="p-0">
      <app-datatable
        [configurationInput]="datatableConfigurations"
        [rowData]="rows()"
        [columns]="datatableColumns"
        [total]="store.dataTotal$()"
        [customColumnDef]="[
          { name: 'name', template: nameCell, isSortable: true },
          { name: 'bones', template: bonesCell, isSortable: false },
        ]"
        (deleteClick)="initializeDelete()"
        (editClick)="initializeEdit()"
        (duplicateClick)="initializeDuplicate()"
        (addClick)="initializeAdd()"
        (dataRefreshRequest)="datatableParams$.next($event)"
        (selectedItemsChange)="selectedDatatableItems.set($event)"
      />
    </mat-card-content>
  </mat-card>
</div>

<ng-template #nameCell let-row="row">
  <div class="d-flex align-items-center">
    <span class="link-button" (click)="openTemplate(row)">{{ row.name }}</span>
    @if (row.isDefault) {
      <mat-chip class="ms-2" selectable="false">{{ 'system.label.default' | translate | uppercase }}</mat-chip>
    }
  </div>
</ng-template>

<ng-template #bonesCell let-row="row">
  <div class="it-bones">
    @for (bone of row.bones; track bone.id) {
      <span class="it-bone-pill" [style.--it-bone-color]="bone.color">
        <mat-icon>{{ bone.icon }}</mat-icon>
        <span class="it-bone-pill-label">{{ bone.name }}</span>
      </span>
    }
  </div>
</ng-template>
